import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import pdf_img from "../../assets/images/pdf_img.png";

export default function HomeWorkPdf() {
  return (
    <>
      <Row className="m-auto mt-4">
        <Col lg={12} className="sent_blue rounded-3 pt-2 pb-3 mb-2">
          <Row className="justify-content-md-between">
            <Col lg={8}>
              <p className="f-13 mb-1">Home Work Message</p>
            </Col>
          </Row>

          <p className="f-12">
            Mr.Sandeep Sir<span className="pl-3 pr-3">|</span>16 Jun.11:59pm
          </p>

          <Row className="f-12 pb-3">
            <Col xs={2} className="pe-0">
              <img src={pdf_img} alt="" width="30px" height="38px" />
            </Col>
            <Col xs={5} className="ps-0 d-flex align-items-end">
              Initial Test - Telugu Telugu
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
